import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerifiedPnlRoutingModule } from './verified-pnl-routing.module';
import { VerifiedPnlComponent } from './verified-pnl.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    VerifiedPnlComponent
  ],
  imports: [
    CommonModule,
    VerifiedPnlRoutingModule,FormsModule,
    SharedModule
  ]
})
export class VerifiedPnlModule { }
